import React, { useContext, useEffect, useRef, useState } from 'react'
import { stateContext } from './Context'

export const InsertTable = (props) => {

  const {quill, tableObj, showModal, setShowModal} = useContext(stateContext)

  let initialGridValue = {
    row: '',
    column: '',
  }
    
  let [grid, setGrid] = useState(initialGridValue)
    
  const gridInputHandler = (e) => {
    var { name, value } = e.target;
    setGrid({
      ...grid,
      [name]: value,
    });     
  }

  // Table Functionalities 
  useEffect(() => {
    if(quill && tableObj){
      let tableActionPicker = document.querySelector('.ql-picker.ql-tableaction .ql-picker-options').childNodes;
      tableActionPicker.forEach((listItem) => {
        let dataValue = listItem.getAttribute('data-value')
        listItem.addEventListener('click', () => {
          switch(dataValue){
            case "Insert-row-above":
              tableObj.insertRowAbove();
            break;
            case "Insert-row-below":
                tableObj.insertRowBelow();
              break;
            case "Insert-column-left":
                tableObj.insertColumnLeft();
              break;
            case "Insert-column-right":
                tableObj.insertColumnRight();
              break;
            case "Delete-row":
                tableObj.deleteRow();
            case "Delete-column":
                tableObj.deleteColumn();
              break;
            case "Delete-table":
                tableObj.deleteTable();
              break;
            default:
              console.log('something is wrong.')
              break;
          }
        })
      })
    }
  }, [quill, tableObj])
    
  const insertGridValue = () => {
    quill.focus();
    tableObj.insertTable(parseInt(grid.row) , parseInt(grid.column));
    setShowModal(!showModal)
  } 


  return (
    <div className='insert-table-div'>
        <h3>Insert Table</h3> 
          <input type="number" name="row" placeholder="Row"
              onChange={gridInputHandler}
              value={grid.row} />
          <span>X</span>
          <input type="number" name="column" placeholder="Column"
            onChange={gridInputHandler}
            value={grid.column} />
        <button onClick={insertGridValue}>Insert</button>
    </div>
  )
}
